import * as React from 'react'

import CashAfterpayLogo from './CashAfterpayLogo'
import CashAppLogo from './CashAppLogo'

export type LogoSvgProps = {
  altText?: string
  logoColor: string
  textColor: string
  symbolColor: string
  solidCurrencySymbol?: boolean
} & React.SVGAttributes<SVGElement>

type Logo = (props: LogoSvgProps) => JSX.Element

export type SupportedRegion = 'US' | 'GB' | 'IE'
export const SupportedRegions = new Set<SupportedRegion>(['US', 'GB', 'IE'])
export type ColorVariants =
  | 'default'
  | 'white'
  | 'black'
  | 'investingPurple'
  | 'green'
  | 'greenLogoWhiteText'
  | 'greenLogoBlackText'
  | 'cashAppCard'
  | 'greenMonochrome'

export type LogoVariants = 'default' | 'taxes' | 'cashAfterpay'

export type LogoProps = {
  colorVariant?: ColorVariants
  region?: SupportedRegion
  variant?: LogoVariants
  withText?: boolean
} & Omit<LogoSvgProps, 'logoColor' | 'symbolColor' | 'textColor'>

const Logo = ({
  altText,
  colorVariant = 'default',
  variant = 'default',
  withText,
  solidCurrencySymbol,
  ...props
}: LogoProps) => {
  if (variant === 'cashAfterpay') {
    return <CashAfterpayLogo altText={altText} {...props} />
  }

  return (
    <CashAppLogo
      variant={variant === 'taxes' ? 'taxes' : colorVariant}
      withText={withText}
      altText={altText}
      {...(variant === 'taxes' ? { height: 26 } : {})}
      {...props}
    />
  )
}

export default Logo
